import * as yup from "yup";
import { phoneNumberSchema } from "../../common/layout/form/phoneNumberRules";

export const validationSchemaDrivers = (translations: any) => yup.object().shape({
  lastName: yup.string().required(translations.lastNameRequired).max(50),
  firstName: yup.string().required(translations.firstNameRequired).max(50),
  phone: phoneNumberSchema("phonePrefix").nullable(),
  email: yup
    .string()
    .email(translations.emailInvalid)
    .required(translations.emailRequired)
    .max(50),
});
